// extracted by mini-css-extract-plugin
export var select = "_or-0";